import React from 'react';
import styles from './index.module.less';

export function Gate(props) {
    return <>gate</>
}